/**
 * @module builder
 */

import type { OptionsDocument, QuoteDocument } from 'paintscout'
import type { BulkOperation } from '../index'
import { translateBulkOperations } from '../index'
import { handleLineItemOperations } from '../handle-line-item-operations'
import { handleSubstrateOperations } from '../handle-substrate-operations'

export function handleBulkOperations(
  quote: QuoteDocument,
  operations: BulkOperation[],
  options: OptionsDocument
): QuoteDocument {
  // Translate each executableOperation into a line item or substrate operation.
  const [lineItemOperations, substrateOperations] = translateBulkOperations(operations)
  // Carry out all line item operations
  const lineItemQuote = handleLineItemOperations({ quote, options, lineItemOperations })
  // Carry out all substrate operations
  const updatedQuote = handleSubstrateOperations({ givenQuote: lineItemQuote, substrateOperations, options })

  return updatedQuote
}
